import React from "react";

const BLACK = "https://customer-assets.emergentagent.com/job_core-agent-ops/artifacts/hrgxqg2a_VECTOR%20FILE%20Core%20Logo%20Black%20Transparent%20.svg";
const WHITE = "https://customer-assets.emergentagent.com/job_core-agent-ops/artifacts/2oajn199_VECTOR%20FILE%20Core%20Logo%20White%20Trasparent.svg";

export default function Logo({ variant = "black", className = "", height = 36, alt = "CORE Realty and Associates" }) {
  const src = variant === "white" ? WHITE : BLACK;
  return <img src={src} alt={alt} style={{ height }} className={`w-auto select-none ${className}`} draggable={false} />;
}
